import React from "react";
import {Link, useRouteMatch, useLocation} from 'react-router-dom'
import useQueryString from "../utils/queryString";

const Pagination = ({meta, states, baseURI}) => {
    let {path, url} = useRouteMatch();

    if (baseURI === undefined) {
        baseURI = url;
    }

    const { search } = useLocation();

    const getQueryString = (pageNumber) => {
        if (states === undefined) {
            let queryString = useQueryString.createQueryStr(search, {page: pageNumber});
            return queryString;
        } else {
            let queryString = useQueryString.createQueryFromObj({page: pageNumber, ...states});
            return queryString;
        }
    }

    if (meta.total <= meta.per_page) return <></>;

    const paginationLinks = [];
    for (let i= 1; i <= meta.last_page; i++) {
        paginationLinks.push(<li className={i === meta.current_page ? 'page-item active' : 'page-item'}>
            <Link className="page-link" to={baseURI+getQueryString(i)}>{i}</Link></li>)
    }


    return (
        <nav aria-label="Page navigation example">
            <ul className="pagination">
                <li className={ meta.current_page === 1 ? 'page-item disabled' : 'page-item'}>
                    <Link className="page-link"
                          to={baseURI+getQueryString(meta.current_page - 1)}>قبلی</Link></li>
                {paginationLinks}
                <li className={ meta.current_page === meta.last_page ? 'page-item disabled' : 'page-item'}>
                    <Link className="page-link"
                          to={baseURI+getQueryString(meta.current_page + 1)}>بعدی</Link></li>
            </ul>
        </nav>
    )
}

export default Pagination
